import React, { createContext, useContext, useEffect, useState } from "react";
import { Service } from "../constants/actionType";

export const TILE_THEMES = {
  default: "stone",
  MM4: "stone",
  MM3: "white",
}

export const TileThemeContext = createContext(TILE_THEMES.default);

export const useTileTheme = () => useContext(TileThemeContext);

function getTileTheme(product, serviceType) {
  try {
    if (serviceType === Service.internet) {
      if (product?.productKeyword?.includes?.("MM4")) {
          return TILE_THEMES.MM4;
      } else if (product?.productKeyword?.includes?.("MM3")) {
        return TILE_THEMES.MM3;
      }
    }
  } catch (e) {
    console.error(e);
  }
  return TILE_THEMES.default;
}

export const withTileTheme = (Component) => (props) => {
  const {
    product,
    serviceType,
  } = props;

  const [theme, setTheme] = useState(getTileTheme(product, serviceType));

  useEffect(() => {
    if (serviceType === Service.internet) {
      setTheme(getTileTheme(product, serviceType));
    }
  }, product);

  return (
    <TileThemeContext.Provider value={theme}>
      <Component {...props} />
    </TileThemeContext.Provider>
  );
};
